/* template */
<template><page><base-container :class='["cube-radio-modal-page"]'><radio-modal-default :class='["demo-item"]'/><radio-modal-option-conf :class='["demo-item"]'/><radio-modal-cancel-btn :class='["demo-item"]'/><radio-modal-slots :class='["demo-item"]'/></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_67065009"}'>
.cube-radio-modal-page
  .demo-item:not(:last-child)
    display block
    margin-bottom: 10px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_67065009"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_67065009"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_67065009"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'radio-modal-default':getComponent(require("./radio-modal-default.mpx?isComponent&outputPath=components%2Fradio-modal-default52146586%2Findex")),'radio-modal-option-conf':getComponent(require("./radio-modal-option-conf.mpx?isComponent&outputPath=components%2Fradio-modal-option-conf6886577e%2Findex")),'radio-modal-cancel-btn':getComponent(require("./radio-modal-cancel-btn.mpx?isComponent&outputPath=components%2Fradio-modal-cancel-btn356e5812%2Findex")),'radio-modal-slots':getComponent(require("./radio-modal-slots.mpx?isComponent&outputPath=components%2Fradio-modal-slots85d2da0c%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>